import LanguagesService from '@/api/admin/languages.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
    languageModel: {},
  },
  getters: {
    getLanguages: state => state.table,
    getLanguageModel: state => state.languageModel,
  },
  actions: {
    async getLanguages({ commit }) {
      const languages = await LanguagesService.getLanguages()
      commit('SET_LANGUAGES', languages)
    },
  },
  mutations: {
    SET_LANGUAGES(state, languages) {
      state.table.rows = languages
    },
    SET_LANGUAGE_MODEL(state, language) {
      state.languageModel = language
    },
  },
}
